// extracted by mini-css-extract-plugin
module.exports = {"ScrollDown":"ScrollDown_ScrollDown__HbYRq","arrowDown":"ScrollDown_arrowDown__Y228N","ScrollUp":"ScrollDown_ScrollUp__CyCWw","arrowUp":"ScrollDown_arrowUp__CmN_D"};